import TrackingWidget from "@/components/TrackingWidget";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function Tracking() {
  return (
    <section className="mx-auto max-w-3xl px-5 pb-24 pt-36" data-testid="tracking-page">
      <SectionHeading as="h1" eyebrow="سیستم رهگیری پرونده" title="وضعیت پرونده خود را <span class='gold-text'>در لحظه</span> ببینید" desc="هر پرونده گروه ۷ یک کد رهگیری اختصاصی دارد. مرحله جاری، تاریخ به‌روزرسانی‌ها، وکیل مسئول و اقدام بعدی — همه شفاف و ۲۴ ساعته." />
      <Reveal delay={0.1} className="mt-12">
        <TrackingWidget full />
      </Reveal>
      <Reveal delay={0.2} className="mt-12">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            { t: "کد در قرارداد و پیامک", d: "کد رهگیری در قرارداد و پیامک خوش‌آمدگویی برای شما ارسال می‌شود." },
            { t: "به‌روزرسانی لحظه‌ای", d: "هر اقدام حقوقی بلافاصله در سامانه ثبت و تاریخ‌گذاری می‌شود." },
            { t: "امنیت اطلاعات", d: "جزئیات پرونده فقط برای دارنده کد رهگیری قابل مشاهده است." },
          ].map((c, i) => (
            <div key={c.t} className="card-glow rounded-3xl border border-gold/15 bg-navy-850 p-6" data-testid={`tracking-feature-${i + 1}`}>
              <h4 className="font-display text-sm font-bold text-gold">{c.t}</h4>
              <p className="mt-2 text-xs leading-6 text-slate-400">{c.d}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
